import { ProfileApi } from 'api/ApiHelper';
import { AxiosRequestConfig } from 'axios';
import { profileQueryKey } from 'queries/profile/queryKey';
import { QueryClient, useQuery } from '@tanstack/react-query';

export const useGetProfileQuery = (profileId: number) =>
  useQuery({ queryKey: profileQueryKey.profile(profileId), queryFn: () => ProfileApi.findProfileById(profileId) });

export const prefetchProfileQuery = (queryClient: QueryClient, options: AxiosRequestConfig, profileId: number) =>
  queryClient.prefetchQuery({
    queryKey: profileQueryKey.profile(profileId),
    queryFn: () => ProfileApi.findProfileById(profileId, options),
  });
